import { LotOfferStatus } from '../../../../core/constants/lot-offer-status.enum'
import { LotOffer } from '../../../../core/models'

export class OfferHelper {
    static isOfferActive(o: LotOffer) {
        return o && [LotOfferStatus.Offered, LotOfferStatus.Cancelling].includes(o.status)
    }

    static isOfferCancelling(o: LotOffer) {
        return o && [LotOfferStatus.Cancelling].includes(o.status)
    }

    static isOfferCancelled(o: LotOffer) {
        return o && [LotOfferStatus.Cancelled].includes(o.status)
    }

    static isMadeToBidderId(o: LotOffer, bidderId: number) {
        return o && o.auctionBidderId === Number(bidderId || 0)
    }
}
